import { Component, Prop, h } from '@stencil/core'

@Component({
  tag: 'clear-search-button',
  styleUrl: 'clear-search-button.scss',
})
export class ClearSearchButton {
  @Prop() show: boolean

  render() {
    if (!this.show) return null
    return (
      <div class="c11n-search__form__input-row__input__clear">
        <button
          type="button"
          aria-label="Clear search input"
          class="c11n-button c11n-button--small c11n-button--icon-ghost c11n--on-light"
        >
          <span class="c11n-button__box">
            <span class="c11n-button__icon-only">
              <svg class="c11n-remove-small" id="remove-small" viewBox="0 0 14 14">
                <path
                  d="M8.591,7.177a.25.25,0,0,1,0-.354l4.616-4.616A1,1,0,1,0,11.793.793L7.177,5.409a.25.25,0,0,1-.354,0L2.207.793A1,1,0,0,0,.793,2.207L5.409,6.823a.25.25,0,0,1,0,.354L.793,11.793a1,1,0,0,0,1.414,1.414L6.823,8.591a.25.25,0,0,1,.354,0l4.616,4.616a1,1,0,0,0,1.414-1.414Z"
                >
                </path>
              </svg>
            </span>
          </span>
        </button>
      </div>
    )
  }
}
